import { Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { sideMenuStructure } from "../routes";

// Page titles by path, taken from the side menu
const PAGE_TITLES = Object.fromEntries(
    sideMenuStructure.flatMap((parent) =>
        parent.children.map((child) => [child.path, child.title]),
    ),
);

/**
 * Heading showing the current page's name, as it appears in the side menu.
 * Renders nothing for pages that aren't in the side menu.
 */
export default function PageHeading() {
    const location = useLocation();
    const title = PAGE_TITLES[location.pathname];

    if (!title) return null;

    return (
        <Typography variant="h5" component="h1" sx={{ px: 2.5, pt: 2.5, fontWeight: 700 }}>
            {title}
        </Typography>
    );
}
